document.addEventListener("DOMContentLoaded", function () {
  const pictures = document.querySelectorAll('picture.lazy-picture');

  pictures.forEach(picture => {
    const sources = picture.querySelectorAll('source[data-srcset]');
    sources.forEach(source => {
      const fullSrcSet = source.getAttribute('data-srcset');
      if (fullSrcSet) source.setAttribute('srcset', fullSrcSet);
    });

    const img = picture.querySelector('img.lazy-swap');
    const fullImgSrc = img.getAttribute('data-src');
    if (fullImgSrc) {
      const tempImg = new Image();
      tempImg.src = fullImgSrc;
      tempImg.onload = () => {
        img.src = fullImgSrc;
      };
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("Modal");
  const btns = document.querySelectorAll(".openModal");
  const span = document.getElementsByClassName("CloseButton")[0];
  const iframe = document.getElementById("youtubeIframe");

  // Liquidから渡された値を使用
  const videoID = window.mySectionData?.youtubeID;
  if (!videoID) return;

  const videoURL = `https://www.youtube.com/embed/${videoID}?autoplay=1&mute=1`;

  btns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      iframe.src = videoURL;
      modal.style.display = "block";
    });
  });

  if (span) {
    span.onclick = function () {
      iframe.src = "";
      modal.style.display = "none";
    };
  }

  window.addEventListener("click", function (event) {
    if (event.target.classList.contains("modal")) {
      iframe.src = "";
      modal.style.display = "none";
    }
  });
});